import React, { useState, useContext } from "react";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import Multiselect from "multiselect-react-dropdown";
import { errorResponseMessage } from "../shared/const.prop";

const Feedback = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [feedback, setFeedback] = useState("");
  const [sessionIssue, setSessionIssue] = useState([]);
  const [factors, setFactors] = useState([]);
  const [use, setUse] = useState("");
  const [recom, setRecom] = useState("");
  const [reason, setReason] = useState([]);
  const [testimonial, setTestimonial] = useState("");

  const { user } = authContext;

  const feedbackHandler = async () => {
    let payload = {
      userId: data?.mentor_id,
      subject: data?.expertise,
      appointmentId: data?.id,
      sessionFeedback: feedback,
      sessionIssue: sessionIssue,
      useApplication: use,
      appFactors: factors,
      appRecommendation: recom,
      reason: reason,
      description: testimonial,
    };
    try {
      const getFeedback = await axiosHttp.post(`testimonials`, {
        ...payload,
      });
      if (getFeedback.status === 201) {
        appContext.updateModalState();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const handleChange = (e) => {
    setFeedback(e.target.value);
  };

  const handleUseChange = (e) => {
    setUse(e.target.value);
  };

  const handleRecommendationChange = (e) => {
    setRecom(e.target.value);
  };

  return (
    <div>
      <div className="modal-body">
        <div className="card card-modal h-auto">
          <div className="card-body">
            <div class="form-group">
              <label for="session_rating">1. How did the session go?</label>
              <select
                class="form-control"
                name="session_rating"
                id="session_rating"
                required
                onChange={handleChange}
              >
                <option value="">Please Select</option>
                <option value="satisfactory">Satisfactory</option>
                <option value="unsatisfactory">Unsatisfactory</option>
              </select>
            </div>
            {feedback === "unsatisfactory" && (
              <div class="form-group">
                <label for="session_issues">
                  If you chose "Unsatisfactory," kindly elaborate on the issues
                  encountered (select multiple):
                </label>
                <Multiselect
                  options={[
                    "Queries were unresolved",
                    "Call quality issues - Audio",
                    "Call quality issues - Video",
                    "Call quality issues - Connectivity",
                    "Absent participation by other attendees",
                    "Others",
                  ]}
                  hidePlaceholder={true}
                  placeholder="select/search and select"
                  closeOnSelect={false}
                  onSelect={(selectItem) => setSessionIssue(selectItem)}
                  onRemove={(removeItem) => setSessionIssue(removeItem)}
                  isObject={false}
                  className="multi-select-wrapper"
                />
              </div>
            )}

            <div class="form-group">
              <label for="use_again">
                2. How likely are you to use our application again?
              </label>
              <select
                class="form-control"
                name="use_again"
                id="use_again"
                required
                onChange={handleUseChange}
              >
                <option value="">Please Select</option>
                <option value="definitely">Definitely</option>
                <option value="unsure">Unsure</option>
              </select>
            </div>

            {use === "unsure" && (
              <div class="form-group">
                <label for="factors_influence_decision">
                  If uncertain, what factors influence your decision? (select
                  multiple):
                </label>
                <Multiselect
                  options={[
                    "Call quality concerns - Audio",
                    "Call quality concerns - Video",
                    "Call quality concerns - Connectivity",
                    "Lack of participation by others",
                    "Others",
                  ]}
                  hidePlaceholder={true}
                  placeholder="select/search and select"
                  closeOnSelect={false}
                  onSelect={(selectItem) => setFactors(selectItem)}
                  onRemove={(removeItem) => setFactors(removeItem)}
                  isObject={false}
                  className="multi-select-wrapper"
                />
              </div>
            )}

            <div class="form-group">
              <label for="recommendation_likelihood">
                3. How likely are you to recommend our application to your
                network?
              </label>
              <select
                class="form-control"
                name="recommendation_likelihood"
                id="recommendation_likelihood"
                required
                onChange={handleRecommendationChange}
              >
                <option value="">Please Select</option>
                <option value="highly_likely">Highly Likely</option>
                <option value="not_certain">Not Certain</option>
              </select>
            </div>

            {recom === "not_certain" && (
              <div class="form-group">
                <label for="reasons_not_likely">
                  If not likely, please specify reasons:
                </label>
                <Multiselect
                  options={[
                    "Challenges with user-friendliness",
                    "Limited opportunities for connections",
                    "Others",
                  ]}
                  hidePlaceholder={true}
                  placeholder="select/search and select"
                  closeOnSelect={false}
                  onSelect={(selectItem) => setReason(selectItem)}
                  onRemove={(removeItem) => setReason(removeItem)}
                  isObject={false}
                  className="multi-select-wrapper"
                />
              </div>
            )}

            <div class="form-group">
              <label for="testimonial">4. Testimonial (limit 50 words):</label>
              <textarea
                class="form-control"
                name="testimonial"
                id="testimonial"
                rows="4"
                maxlength="50"
                onChange={(e) => setTestimonial(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-2 mb-3">
        <button
          type="button"
          class="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={() => appContext.updateModalState()}
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-outline-primary modal-btn"
          disabled={feedback === ""}
          onClick={feedbackHandler}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default Feedback;
